const DEVICE_COOKIE = 'wz_device_id';
// Browsers cap cookie lifetime at ~400 days; it is re-set on every use, so it keeps rolling.
const DEVICE_COOKIE_MAX_AGE = 60 * 60 * 24 * 400;

// Random per-browser id for new-device detection; a cookie because logout runs localStorage.clear().
export const getDeviceId = (): string => {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${DEVICE_COOKIE}=([A-Za-z0-9-]{8,64})`));
    const id = match
      ? match[1]
      : (window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`);
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${DEVICE_COOKIE}=${id}; max-age=${DEVICE_COOKIE_MAX_AGE}; path=/; SameSite=Lax${secure}`;
    return id;
  } catch {
    return '';
  }
};

// System details sent with login for the Audit Trail; best-effort, never throws.
export const collectClientInfo = async (): Promise<Record<string, any>> => {
  try {
    const nav: any = navigator;
    const info: Record<string, any> = {
      deviceId: getDeviceId(),
      platform: nav.userAgentData?.platform || nav.platform || '',
      language: nav.language || '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      screen: `${window.screen.width}x${window.screen.height}`,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      pixelRatio: window.devicePixelRatio || 1,
      cores: nav.hardwareConcurrency,
      memory: nav.deviceMemory,
      touch: (nav.maxTouchPoints || 0) > 0,
      connection: nav.connection?.effectiveType,
    };

    // Chromium only: exact OS version (tells Windows 11 from 10) and phone model.
    if (nav.userAgentData?.getHighEntropyValues) {
      try {
        const hints = await nav.userAgentData.getHighEntropyValues(['platformVersion', 'model']);
        info.platformVersion = hints.platformVersion;
        info.model = hints.model;
        info.mobile = nav.userAgentData.mobile;
      } catch { /* hints are optional */ }
    }

    return info;
  } catch {
    return {};
  }
};
